'use client';

import { useEffect, useState } from 'react';

// Prerendered fallback for the © year, corrected client-side after hydration.
// new Date() at render time blocks the static shell under cacheComponents.
const FALLBACK_YEAR = 2026;

export function CopyrightYear() {
  const [year, setYear] = useState(FALLBACK_YEAR);

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  return <>{year}</>;
}
